import '.ey{flex-shrink:0;}.ssr-plugin'
import '.i2{min-width:260px;}.ssr-plugin'
import '.j{max-width:480px;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.o{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.b1{user-select:none;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.aa{gap:24px;}.ssr-plugin'
import '.m{flex:1;}.ssr-plugin'
import '.d1{overflow:auto;}.ssr-plugin'
import '.f6{gap:2px;}.ssr-plugin'
import '.i3{padding:8px 8px 4px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.i4{padding-top:4px;}.ssr-plugin'
import '.i5{padding-bottom:4px;}.ssr-plugin'
import '.bv{padding-left:8px;}.ssr-plugin'
import '.ga{padding-right:8px;}.ssr-plugin'
import '.gn{min-height:32px;}.ssr-plugin'
import '.b8{gap:8px;}.ssr-plugin'
import '.a9{cursor:pointer;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.i6{min-height:24px;}.ssr-plugin'
import { ReactNode, createContext, useContext } from 'react'
import { Icon, IconProps } from '../Icon/index.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { Counter } from '../Counter/index.js'

type SidebarContextType = {
  value?: string
  onChange: (value: string) => void
}
const SidebarContext = createContext<SidebarContextType>({ onChange: () => {} })

type SidebarProps = {
  value?: string
  onChange: (value: string) => void
  children: ReactNode
  side?: 'left' | 'right' | false
}

function Sidebar({ children, value, onChange, side = 'left' }: SidebarProps) {
  return (
    <SidebarContext.Provider value={{ value, onChange }}>
      <div className="ey i2 j n o a i b1"
      >
        <div className="h o a i aa"
        >
          {children}
        </div>
      </div>
    </SidebarContext.Provider>
  )
}

type SidebarHeaderProps = {
  children: ReactNode
}

function SidebarHeader({ children }: SidebarHeaderProps) {
  return <div className="a">{children}</div>
}

type SidebarFooterProps = {
  children: ReactNode
}

function SidebarFooter({ children }: SidebarFooterProps) {
  return <div className="a">{children}</div>
}

type SidebarItemsProps = {
  children: ReactNode
}

function SidebarItems({ children }: SidebarItemsProps) {
  return (
    <div className="m aa a h i d1"
    >
      {children}
    </div>
  )
}

type SidebarGroupProps = {
  children: ReactNode
  title: string
}

function SidebarGroup({ title, children }: SidebarGroupProps) {
  return (
    <div className="a i f6">
      <div className="i3">
        <Text selectableText={false} variant="subtext-medium" color="neutral60">
          {title}
        </Text>
      </div>
      {children}
    </div>
  )
}

type SidebarItemProps = {
  children: ReactNode
  value: string
  icon?: IconProps['variant']
  description?: string
  counter?: number
}

function SidebarItem({
  children,
  value,
  icon,
  description,
  counter,
}: SidebarItemProps) {
  const { value: contextValue, onChange } = useContext(SidebarContext)
  const active = value === contextValue

  return (
    <styled.div className="a d i4 i5 bv ga gn b8 a9"
      data-active={active ? active : undefined}
      style={{
        borderRadius: radius[12],
        '&:hover:not([data-active])': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]:hover': {
          background: colors.neutral10Adjusted,
        },
      }}
      onClick={() => {
        onChange(value)
      }}
    >
      {icon && <Icon variant={icon} />}
      <div className="a i c a3 i6"
      >
        <Text selectableText={false} color="neutral80" variant="display-medium">
          {children}
        </Text>
        {description && (
          <Text
            selectableText={false}
            color="neutral60"
            variant="subtext-regular"
          >
            {description}
          </Text>
        )}
      </div>
      {counter > 0 && (
        <Counter style={{ marginLeft: 'auto' }}>{counter}</Counter>
      )}
    </styled.div>
  )
}

Sidebar.Items = SidebarItems
Sidebar.Group = SidebarGroup
Sidebar.Item = SidebarItem
Sidebar.Header = SidebarHeader
Sidebar.Footer = SidebarFooter

export { Sidebar }
export type { SidebarProps }
